import { LmResponse } from '@vfde-sails/avc-core';
import { LmFormAction } from './enum';
import { LmForm } from './interface';
import { AppError } from '../../container/App/interface';

/**
 * Submits lm form
 */
export const submitLmForm = () => ({
    type: LmFormAction.SUBMIT_LM_FORM,
} as const);

/**
 * Handles lm response
 */
export const handleLmResponse = (payload: LmResponse) => ({
    type: LmFormAction.HANDLE_LM_RESPONSE,
    payload,
} as const);

/**
 * Handle lm error
 */
export const handleLmResponseError = (payload: AppError) => ({
    type: LmFormAction.HANDLE_LM_RESPONSE_ERROR,
    payload,
} as const);

/**
 * Changes lm input
 */
export const changeLmInput = (payload: Partial<LmForm>) => ({
    type: LmFormAction.CHANGE_LM_INPUT,
    payload,
} as const);

/**
 * Clears lm result
 */
export const clearLmResult = () => ({
    type: LmFormAction.CLEAR_LM_RESULT,
} as const);

/**
 * LM Actions
 */
export type Actions = ReturnType<typeof submitLmForm>
    | ReturnType<typeof handleLmResponse>
    | ReturnType<typeof handleLmResponseError>
    | ReturnType<typeof changeLmInput>
    | ReturnType<typeof clearLmResult>;
